import type {
  AssessmentAttachment,
  CoachCoverageAttachment,
  ConferenceAttachment,
  FileAttachment,
  FoodShareAttachment,
  MaterialAttachment,
  PostAttachment,
  QuestionnaireAttachment,
  ReplyAttachment,
  TaskAttachment,
  UserAttachment,
} from '../../../api/channel/post';
import type {FileApiModel} from '../../../api/media/file';
import type {Nullable} from '../../utility-types';

import {getEntityTypeById} from '../getEntityType';

// _id can be null in case of native File

export const isImageAttachment = (
  item?: Nullable<PostAttachment>,
): item is FileAttachment =>
  Boolean(item && (item as FileApiModel).categories?.includes('image'));

export const isAudioAttachment = (
  item?: Nullable<PostAttachment>,
): item is FileAttachment =>
  Boolean(item && (item as FileApiModel).categories?.includes('audio'));

export const isMaterialAttachment = (
  item?: Nullable<PostAttachment>,
): item is MaterialAttachment =>
  Boolean(item && getEntityTypeById(item._id || '') === 'material');

export const isPostAttachment = (
  item?: Nullable<PostAttachment>,
): item is ReplyAttachment =>
  Boolean(item && getEntityTypeById(item._id || '') === 'post');

export const isUserAttachment = (
  item?: Nullable<PostAttachment>,
): item is UserAttachment =>
  Boolean(item && getEntityTypeById(item._id || '') === 'user');

export const isQuestionnaireAttachment = (
  item?: Nullable<PostAttachment>,
): item is QuestionnaireAttachment =>
  Boolean(item && getEntityTypeById(item._id || '') === 'questionnaire');

export const isAssessmentAttachment = (
  item?: Nullable<PostAttachment>,
): item is AssessmentAttachment =>
  Boolean(item && getEntityTypeById(item._id || '') === 'bound_form');

export const isFileAttachment = (
  item?: Nullable<PostAttachment>,
): item is FileAttachment | MaterialAttachment =>
  Boolean(
    item && (!!(item as FileApiModel).categories || isMaterialAttachment(item)),
  );

export const isShareFoodAttachment = (
  item?: Nullable<PostAttachment>,
): item is FoodShareAttachment =>
  Boolean(item && getEntityTypeById(item._id || '') === 'food_share');

export const isVideoAttachment = (
  item?: Nullable<PostAttachment>,
): item is FileAttachment =>
  Boolean(item && (item as FileApiModel).categories?.includes('video'));

export const isDocumentAttachment = (
  item?: Nullable<PostAttachment>,
): item is FoodShareAttachment => {
  return Boolean(
    item && (item as FileApiModel).categories?.includes('document'),
  );
};

export const isLinkAttachment = (
  item?: Nullable<PostAttachment>,
): item is FileAttachment =>
  Boolean(item && (item as FileApiModel).categories?.includes('website'));

export const isConferenceAttachment = (
  item?: Nullable<PostAttachment>,
): item is ConferenceAttachment =>
  Boolean(item && getEntityTypeById(item._id || '') === 'conference');

export const isTaskAttachment = (
  item?: Nullable<PostAttachment>,
): item is TaskAttachment =>
  Boolean(item && getEntityTypeById(item._id || '') === 'task');

export const isCoachCoverageAttachment = (
  item?: Nullable<PostAttachment>,
): item is CoachCoverageAttachment =>
  Boolean(item && getEntityTypeById(item._id || '') === 'coach_history');
